<template>
  <div class="article-link">
    <h3>{{ title }}</h3>
    <p>
      <slot />
    </p>
    <p class="small soft">{{ href }}</p>
    <a :href="`//${href}`"></a>
  </div>
</template>

<script>
export default {
  name: 'FlexItem',

  props: {
    href: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="sass" scoped>
@import '@/styles/variables.sass'

.article-link
  position: relative
  transition: all 150ms ease-in-out
  &:hover
    color: $main-color
    h3
      &:before
        opacity: 0
      &:after
        transform: scale(1, 1)
  a
    top: 0
    left: 0
    width: 100%
    height: 100%
    display: block
    position: absolute
    &:after
      display: none
  h3
    position: relative
    padding-bottom: $margin * 0.5
    &:before
      left: 0
      width: 100%
      bottom: -2px
      height: 2px
      display: block
      content: ''
      position: absolute
      transition: all 150ms ease-in-out
      background: rgba($font-color, 0.2)
    &:after
      left: 0
      width: 100%
      bottom: -2px
      height: 2px
      display: block
      content: ''
      position: absolute
      transform: scale(0, 1)
      transition: all 150ms ease-in-out
      background: $main-color
  p
    max-width: 100%
  p.small.soft
    margin-top: $margin * 0.5

.flex-item
  &:nth-child(2)
    .article-link
      margin-left: $margin * 2
</style>
